import React from 'react';
import { List, Pagination, Empty, Spin } from 'antd';
import { InAppNotification } from '../types';
import { NotificationItem } from './NotificationItem';

interface Props {
    notifications: InAppNotification[];
    loading?: boolean;
    showPagination?: boolean;
    currentPage?: number;
    pageSize?: number;
    totalElements?: number;
    onPageChange?: (page: number, size: number) => void;
    onNotificationClick?: (n: InAppNotification) => void;
    onMarkAsRead?: (id: number) => void;
    onDelete?: (id: number) => void;
}

export const NotificationList: React.FC<Props> = ({
    notifications, loading = false, showPagination = true,
    currentPage = 0, pageSize = 20, totalElements = 0,
    onPageChange, onNotificationClick, onMarkAsRead, onDelete,
}) => {
    if (loading) return <div style={{ display: 'flex', justifyContent: 'center', padding: 32 }}><Spin size="large" /></div>;
    if (!notifications?.length) return <Empty description="No notifications found" />;

    return (
        <div>
            <List
                dataSource={notifications}
                renderItem={(n) => (
                    <NotificationItem
                        key={n.id}
                        notification={n}
                        onClick={() => onNotificationClick?.(n)}
                        onMarkAsRead={onMarkAsRead}
                        onDelete={onDelete}
                    />
                )}
            />
            {showPagination && totalElements > pageSize && (
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: 16 }}>
                    <Pagination
                        current={currentPage + 1}
                        pageSize={pageSize}
                        total={totalElements}
                        onChange={(page, size) => onPageChange?.(page - 1, size ?? pageSize)}
                        showSizeChanger
                        showTotal={(total, range) => `${range[0]}-${range[1]} of ${total}`}
                    />
                </div>
            )}
        </div>
    );
};
